export default __webpack_public_path__ + "static/media/1-min.51805289.jpg";